module.exports = __webpack_public_path__ + "img/banner_3.4cab2b45.jpg";